export default {
  button: {
    contact: 'Contact',
    goback: 'Retour',
    login: 'Connexion',
    logout: 'Déconnexion'
  },

  form: {
    login: {
      id: 'Identifiant',
      password: 'Mot de passe'
    }
  },

  label: {
    contact: {
      mail: 'Envoyer un mail',
      phone_bank: 'Contacter le standard'
    }
  },

  title: {
    brand: 'Template',
    contact: 'Contact',
    main: 'PWA'
  }
}
